import styled from 'styled-components';
import {
  Modal as ModalComponent,
  Header as HeaderComponent,
} from 'mondrian-react';

export const Header = styled(HeaderComponent)`
  .cadeado {
    margin-right: 15px;
    .mdn-Icon-senha {
      color: #000000;
    }
  }
`;

export const ModalFaq = styled(ModalComponent)`
  * {
    font-family: 'Roboto';
  }
  .mdn-Heading--xs {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #51555d;
  }
  .mdn-Modal-header {
    padding-bottom: 0;
    min-height: 45px;
    margin-bottom: 5px;
  }
  .mdn-Modal-content {
    max-height: 200px;
    align-self: end;
    max-width: 100%;
    width: 100%;
    padding-left: 40px;
    padding-right: 40px;
  }
`;

export const ModalPrivacidade = styled(ModalComponent)`
  * {
    font-family: 'Roboto';
  }
  .mdn-Heading--xs {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #51555d;
  }
  .mdn-Modal-header {
    padding-bottom: 0;
    min-height: 65px;

    h1 {
      padding-right: 20px;
    }
  }
  .mdn-Modal-content {
    max-height: 280px;
    align-self: end;
    max-width: 100%;
    width: 100%;
    padding-left: 40px;
    padding-right: 40px;

    .mdn-Divider {
      display: none;
      min-height: 0px;
    }
  }
  button:last-child {
    margin-top: 14px;
  }
`;
